import { Dispatch, SetStateAction } from "react";

import CustomToggle from "../CustomToggle";

const ImageOptions = [
  {
    label: "Logo - Square Image with Dynamic Width",
    value: "Logo",
  },
  { label: "Avatar - Circular Image with Replacement Avatar", value: "Avatar" },
];

interface FieldTypeFilesI {
  fieldValues: any;
  setFieldValues: Dispatch<SetStateAction<any>>;
  containerCSS?: string;
}

const FieldTypeFiles = ({
  fieldValues,
  setFieldValues,
  containerCSS,
}: FieldTypeFilesI) => {
  return (
    <>
      <CustomToggle
        title="Public Files"
        description="Files don't need a security layer to access them. Don't enable this
            option if you will upload sensitive data."
        stateName="public"
        value={fieldValues?.public}
        handleChange={(e: any) => {
          const { name, checked } = e.target;

          setFieldValues((prev: any) => ({ ...prev, [name]: checked }));
        }}
        containerCSS={containerCSS}
      />
    </>
  );
};

export default FieldTypeFiles;
